<template>
  <!-- 物流查询 -->
  <div class="logistics-query" v-if="logisticsType != 'DAY_DAY'">
    <!-- <van-nav-bar title="物流查询" left-arrow fixed @click-left="onClickLeft" /> -->
    <div class="logistics">
      <div class="logistics-header">
        <div class="num courier-name">
          <span>{{ logisticsType | codeToName }}</span>
        </div>
          <p class="title"><span>物流单号： </span><span> {{logisticsCode}}</span></p>
        <div class="num order-num">
          <div class="left">
            <span class="logistics-order-name title">订单号：</span>
            <span class="logistics-order title">{{ sourceOrderSn  }}</span>
          </div>
          <div class="right">
            <span
              class="cobyOrderSn"
              @click="copy('.cobyOrderSn')"
              data-clipboard-action="copy"
              :data-clipboard-text="logisticsCode"
              >复制</span
            >
          </div>
        </div>
        <img src="../../assets/coloured.png" class="coloured" />
      </div>

      <div class="steps">
        <span class="logoistics-track">物流跟踪</span>
        <van-steps direction="vertical" :active="active" active-color="#F77403">
          <van-step v-for="(item, index) in stepsList" :key="index">
            <h4>{{ item.remark }}</h4>
            <p>{{ item.acceptTime }}</p>
          </van-step>
        </van-steps>
        <van-empty
          description="没有查询到相关数据"
          :image="emptyImage"
          v-if="isEmpty"
        />
      </div>
    </div>
  </div>

  <!-- 天天快递 -->
  <div v-else class="content-page">
    <iframe id="content" :src="src"></iframe>
  </div>
</template>
<script>
import { Toast } from "vant";
import CONST from "../../utils/constUtils";
let logisticsInfo = {};

export default {
  computed:{
    isEmpty:function(){
      return !this.stepsList.length
    }
  },
  data() {
    return {
      active: 0,
      logisticsCode: null,
      logisticsType: null,
      sourceOrderSn: '',
      stepsList: [],
      src: null,
      emptyImage: require("../../assets/empty.png")
    };
  },

  created() {
    logisticsInfo = this.$route.query.data;
    this.logisticsCode = (logisticsInfo && logisticsInfo.code) || null;
    this.sourceOrderSn = (logisticsInfo && logisticsInfo.sourceOrderSn) || '';
    this.src = `https://www.kuaidi100.com/chaxun?com=天天快递&nu=${this.logisticsCode}`;
    this.logisticsType = logisticsInfo.type;
    this.stepsList = (logisticsInfo && logisticsInfo.list) || [];
    this.sortDate();
  },
  methods: {
    // 时间由小大到排序
    sortDate() {
      this.stepsList.sort((deforeData, afterData) => {
        let aTimeString = deforeData.acceptTime;
        let bTimeString = afterData.acceptTime;
        aTimeString = aTimeString.replace(/-/g, "/");
        bTimeString = bTimeString.replace(/-/g, "/");
        let aTime = new Date(aTimeString).getTime();
        let bTime = new Date(bTimeString).getTime();
        return bTime - aTime;
      });
    },

    // 返回功能
    // onClickLeft() {
    //   this.$router.go(-1);
    // },

    // 复制功能
    copy(value) {
      this.$nextTick(() => {
        let clipboard = new this.$Clipboard(value);
        clipboard.on("success", () => {
          // 释放内存
          Toast("复制成功");
          clipboard.destroy();
        });
        clipboard.on("error", () => {
          // 不支持复制
          console.log("该浏览器不支持自动复制");
          // 释放内存
          clipboard.destroy();
        });
      });
    }
  },

  beforeRouteLeave(to, from, next) {
    const { routes } = this.$router.options;
    const orderListRoute = routes.find(item => item.name == "orderList");
    if (to.name !== "orderList") {
      orderListRoute.meta.keepAlive = false;
    } else {
      orderListRoute.meta.keepAlive = true;
    }
    next();
  }
};
</script>

<style scoped>
.logistics-header .title{
  color:rgba(102,102,102,1);
  font-weight:400;
  font-size:14px;
}
[class*=van-hairline]::after{
  border:none;
}
/deep/ .van-step__circle {
    width: 7px;
    height: 7px;
}
.content-page {
  width: 100%;
  height: 100%;
}

h4{
  font-weight: normal;
  color:#999;
  font-size:14px;
  line-height: 24px;;
}

p{
  line-height: 30px;
}

#content {
  width: 100%;
  height: 100%;
}

.logistics-query {
  background: #f8f8f8;
  height: 100%;
}

.logistics {
  height: 100%;
  /* margin-top: 46px; */
  overflow-y: auto;
  overflow: hidden;
}

.logistics-header {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 13px 10px 50px 16px;
  font-size: 14px;
  text-align: left;
  background: #ffffff;
  box-shadow: 0px 8px 12px #ebedf0;
  height: 84px;
}

.logistics-order {
  color: #333333;
}

.logistics-order-name {
  color: #666666;
}

.coloured {
  position: absolute;
  bottom: 0px;
  left: 0;
  height: 5px;
  width: 100%;
  background: #ffffff;
}

.courier-name,
.num {
  padding-bottom: 10px;
}

.courier-name {
  padding-top: 9px;
  color: #333333;
  font-size: 16px;
}

.order-num {
  display: flex;
}

.left {
  flex: 1;
  line-height: 30px;
}

.steps {
  text-align: left;
  height:calc(100% - 147px);
  overflow-y: auto;
}

.logoistics-track {
  display: inline-block;
  padding: 15px;
  border-bottom: 1px solid #ebebeb;
  font-size: 16px;
  background: #ffffff;
  width: 100%;
  color: #333333;
  box-sizing: border-box;
}

.cobyOrderSn {
  display: inline-block;
  line-height: 30px;
  color: #f77403;
  font-size: 14px;
  margin-right: 10px;
}

.van-empty {
  background: #f8f8f8;
  justify-content: center;
  align-content: center;
  height: calc(100% - 94px);
}

/deep/ .van-empty__image {
  width: 90.5px;
  height: 85px;
}

/deep/.van-nav-bar .van-icon {
  color: #666666;
  font-size: 22px;
}

/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: 505;
}

/deep/ .van-steps--vertical {
  padding: 14px 0 0 32px;
}
</style>
